import api from "./api";

export const getDashboardStats = () =>
  api.get("/admin/stats").then((r) => r.data);

export const getUsers = ({ page = 1, limit = 20, search = "" } = {}) =>
  api.get("/admin/users", { params: { page, limit, search } }).then((r) => r.data);

export const getUserById = (id) =>
  api.get(`/admin/users/${id}`).then((r) => r.data);

export const toggleUserActive = (id) =>
  api.patch(`/admin/users/${id}/toggle`).then((r) => r.data);

// ← search param added here
export const getSubscriptions = ({ page = 1, limit = 20, status = "", search = "" } = {}) =>
  api.get("/admin/subscriptions", { params: { page, limit, status, search } }).then((r) => r.data);

export const createSubscription = ({ user_id, plan_id }) =>
  api.post("/admin/subscriptions", { user_id, plan_id }).then((r) => r.data);

export const cancelSubscription = (id) =>
  api.patch(`/admin/subscriptions/${id}/cancel`).then((r) => r.data);

export const getRevenueSummary = () =>
  api.get("/admin/revenue").then((r) => r.data);

export const getReports = () =>
  api.get("/admin/reports").then((r) => r.data.reports);

export const getPlans = () =>
  api.get("/admin/plans").then((r) => r.data.plans);

export const createPlan = ({ name, duration_days, price }) =>
  api.post("/admin/plans", { name, duration_days, price }).then((r) => r.data);

export const getAdmins = () =>
  api.get("/admin/admins").then((r) => r.data.admins);

export const createAdmin = (data) =>
  api.post("/admin/admins", data).then((r) => r.data);

export const deleteAdmin = (id) =>
  api.delete(`/admin/admins/${id}`).then((r) => r.data);